
import { Config } from 'config';

import { forEach, map, assign, isString } from 'lodash';

import { reject } from 'gear';

import { Document, Font, FontData,
         Figure, Figures, Model3D, ModelData3D, TextureMap3D, QuantumImage } from 'cdl';

let { Cx } = window;

/*
Document.fromCoreX = function(model,bcFixes) {
  const doc = Document.fromXmlString(model.Cdl,bcFixes);

  doc.name =     model.Name;
  doc.modified = model.Modified;
  doc.notes =    model.Notes;
  doc.owned =    model.Owned;
  doc.docType =  model.DocType; // We should check here, docType: Doc3D and xType: System.Document3D should be consistent

  if( doc._owned ) {
    doc.id = model.Id; // sets the ID, which means by default the user saves over the top
    doc._isSaved = true;
    doc.externalId = model.ExternalId;
  }
  // Tags
  doc.tags = []; // map( model.Tags, DocumentTag.fromCore );

  doc.dropPreviousHistoryOnNextCommit();
  return doc ;
};

Document.fromCore$ = function(model) {
  return Document.backwardCompatibleDecoding$(Document.fromCore,model);
};
*/


// https://gist.github.com/jed/982883
function uuid(a) {
  return a?(a^Math.random()*16>>a/4).toString(16):([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,uuid);
}

// config: { app, uuid }
export const CoreXResourceManager = function( config ) {
  assign(this,config);
  if( ! this.namespace ) {
    this.namespace = 'Dev';
  }
  if( ! config.uuid ) {
    this.uuid = uuid;
  }
};

function splitCoreXId(id) {
  var parts = id.split('/');
  return {
    namespace: parts[0],
    id: parts[1]
  };
}

CoreXResourceManager.prototype = {

  get id() {
    return this.namespace;
  },

  serverUrl() {
    var protocol = Config.ssl ? 'https' : 'http';
    return protocol + '://' + ( Config.coreX_server || 'cadxcorextest.azurewebsites.net' ) + '/' ;
  },

  // Font

  loadFontData$( font ) {
    let src = this.fontSrc(font);
    return FontData.localLoad$(font,src);
  },

  fontSrc( font ) {
    // [TODO] Remove, testing until there are resources uploaded
    if( Config.fontTest || ! font.id ) {
      return 'http://cadworx-master-edge.azurewebsites.net/Core2/Font/MatchData?{"config":"Dev","model":{"FamilyName":"Stahls varsity"},"log":{"Environment":null,"ServerAccessToken":null},"ident":{"SessionId":"45f22658-87e3-4a3e-b8ac-4c044b947892","SuperUser":false}}';
    }
    var parts = splitCoreXId(font.id);
    return this.serverUrl() + parts.namespace + '/resource/' + parts.id;
  },

  fontThumbnailUrl(/* font, config */) {
    return '[TODO]';
  },

  // Image

  // { id, preview } => { width, height, preview:base64 }
  imageInfo$( m ) {
    var parts = splitCoreXId(m.id);
    return fetch( this.serverUrl() + parts.namespace + '/meta-image/' + parts.id ) .then( response => {
      return response.json();
    }) .then( meta => {
      return {
        width: meta.width,
        height: meta.height,
        preview: 'data:image/png;base64,' + meta.b64thumb
      };
    });
  },

  // { id, size } => base64
  renderImage$( m ) {
    var parts = splitCoreXId(m.id);
    return fetch( this.serverUrl() + parts.namespace + '/image/' + parts.id + '/' + m.size + '?format=base64' ) .then( response => {
      return response.text();
    }) .then( data => 'data:image/png;base64,' + data );
  },

  // { id, size } => url
  imageUrl( m ) {
    var parts = splitCoreXId(m.id);
    return this.serverUrl() + parts.namespace + '/image/' + parts.id + '/' + m.size;
  },


  // => image$( ... ) => Image


  // Document

  loadDocument$( id ) {
    var parts = splitCoreXId(id);
    return fetch( this.serverUrl() + parts.namespace + '/resource/' + parts.id ) .then( response => {
      return response.text();
    }) .then( xmlString => {
    return Document.fromXmlString$(xmlString) .then( doc => {
    doc.id = id;
    doc._isSaved = true;
    return doc;
    }); });
  },




  saveDocument$( doc ) {
    // Always create a new uuid

    const id = this.uuid();
    const { namespace } = this;
    // POST to id

    var formData = new FormData();

    formData.append(name, data[name]);

    /*
    fetch(url, {
      method: 'POST',
      body: formData
    });

    return fetch( this.serverUrl() + '/meta-resource/', {
      method: 'POST',
      mode: 'CORS',
      headers: {
        "Content-Type": "multipart/form-data"
      },
      body: ''
    }) .then( responseModel => {

    doc.id = id;
    doc._isSaved = true;
    });
    */
  },

  // 3D Resources

  loadDocument3D$( config, options ) {
    return this.loadDocument$(config,options);
  },
  saveDocument3D$( doc ) {
    return this.saveDocument$(doc);
  },

  loadModel3D$( id ) {
    return Cx.Core.Model3D.read$({ Id: id }) .then( model => {
    const model3D = Model3D.fromXmlString(model.Data);
    model3D.id = id;
    return model3D;
    });
  },
  saveModel3D$( model3D ) {
    let operation = model3D._id ? 'update$' : 'create$';

    return Cx.Core.Model3D[operation]({ Data: model3D.toXmlString() })
    .then( responseModel => {

    if(responseModel.Id) {
      model3D.id = responseModel.Id;
    }
    return model3D;
    });
  },

  loadModelData3D$( id ) {
    return Cx.Core.ModelData3D.read$({Id:id}) .then( model => {
    const modelData3D = new ModelData3D({data:JSON.parse(model.Data)});
    modelData3D.id = id;
    return modelData3D;
    });
  },
  saveModelData3D$( modelData3D ) {
    let jsonString = JSON.stringify(modelData3D.data);
    let operation = modelData3D.id ? 'update$' : 'create$';
    return Cx.Core.ModelData3D[operation]({ Data: jsonString }) .then( responseModel => {
    if( responseModel.Id ) {
      modelData3D.id = responseModel.Id;
    }
    return modelData3D;
    });
  },

  createTextureMap3D$( file ) {
    return Cx.Core.Texture3D.create$(file) .then( response => {
    return new TextureMap3D({ id: response.Id });
    });
  },

  renderTexture3D$( model ) {
    return Cx.Core.Texture3D.render$({ Id: model.id, Size: model.size }) .then( model => {
    return model.Data;
    });
  },

  // We can not implement
  // optimizeFigures$( figures ) { ... }
};



/** WEBPACK FOOTER **
 ** ./src/resources/core-x.js
 **/